class BasketControls {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.menu = element;
    // this.closeBtn = this.menu.querySelector('.close');
    this.openBtn = document.querySelectorAll('.basket-open');
    this.init();
  }

  init() {
    if (window.location.hash === '#basket') {
      this.menu.classList.add('open');
    }

    window.addEventListener('basket.closed', () => {
      this.initClose();
    });

    this.openBtn.forEach((link) => {
      link.addEventListener('click', this.initOpen.bind(this));
    });

    // this.closeBtn.addEventListener('click', this.initClose.bind(this));

    // window.addEventListener('basket.modify', this.initOpen.bind(this));
  }

  initOpen(e) {
    if (window.innerWidth >= 767) {
      this.menu.classList.add('open');
      // need this to trick the browser into thinking a resize activity happened
      window.dispatchEvent(new CustomEvent('resize'));
    } else {
      window.location.href = e.target.closest('.basket-open').dataset.basketUrl ?? '/notset.html';
    }
  }

  initClose() {
    console.log('Closing menu');
    this.menu.classList.remove('open');
  }
}

export default BasketControls;
